// extracted by mini-css-extract-plugin
export default {"fullWidth":"do-z","image":"eo-z","lazyLoadPicture":"fo-z","lazyLoadSpinner":"go-z","lazyLoadSpin":"ho-z","lazyLoadImage":"io-z","hasStyledAspectRatio":"jo-z"};